import React, {Component} from "react";
import NavbarC from "./components/Navbar/Navbar";
import Main from "./components/Main/Main";
import AllCountries from "./components/AllCountries/AllCountries";
import AddCountry from "./components/AddCountry/AddCountry";
import CompanyProfile from "./components/CompanyProfile/CompanyProfile";
import Footer from "./components/Footer/Footer";
import "bootstrap/dist/css/bootstrap.min.css";
import {connect} from "react-redux";
import {HashRouter, Route} from "react-router-dom";
import Translate from "react-translate-component";
import counterpart from "counterpart";
import en from "./components/langs/en";
import ar from "./components/langs/ar";

import "./App.css";
counterpart.registerTranslations("en", en);
counterpart.registerTranslations("ar", ar);
class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: "en",
      dir: "ltr",
      textAlign: "left",
      json: {},
    };
  }
  componentDidMount() {
    this.StartscrollTop();
  }
  StartscrollTop = () => {
    let scrollTopBtn = document.querySelector(".scrollTop");
    window.onscroll = () => {
      if (window.innerWidth > 992) {
        if (window.scrollY > 140) {
          scrollTopBtn.style.display = "block";
          document.querySelector(".navPos").classList.add("fixed-top");
          document.querySelector(".title-container").style.height =
            "calc(100% + 140px)";
        } else {
          scrollTopBtn.style.display = "none";
          document.querySelector(".navPos").classList.remove("fixed-top");
          document.querySelector(".title-container").style.height =
            "calc(100% - 140px)";
        }
      } else if (window.innerWidth < 992) {
        if (window.scrollY > 140) {
          scrollTopBtn.style.display = "block";
          document.querySelector(".navPos").classList.remove("fixed-top");
          document.querySelector(".title-container").style.height =
            "calc(100%)";
        } else {
          document.querySelector(".navPos").classList.remove("fixed-top");
          document.querySelector(".title-container").style.height =
            "calc(100%)";
          scrollTopBtn.style.display = "none";
        }
      }
    };
    this.scrollTop();
  };
  scrollTop = () => {
    let scrollTopBtn = document.querySelector(".scrollTop");
    scrollTopBtn.addEventListener("click", () => {
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    });
  };
  render() {
    console.log(this.props);
    return (
      <div className={`App ${this.props.dir}`} dir={this.props.dir}>
        <Translate content="scrollTop" component="div" className="scrollTop" />
        <HashRouter>
          <NavbarC />
          <Route exact path="/">
            <Main />
          </Route>
          <Route path="/allCountries">
            <AllCountries />
          </Route>
          <Route path="/addCountry">
            <AddCountry />
          </Route>
          <Route path="/editCountry">
            <AddCountry
              updatedJson={this.props.getJson}
              countryId={this.props.id}
            />
          </Route>
          <Route path="/companyProfile">
            <CompanyProfile />
          </Route>
        </HashRouter>
        <Footer />
      </div>
    );
  }
}
function mapStateToProps(state) {
  return {
    lang: state.lang,
    dir: state.dir,
    id: state.id,
    json: state.json,
    getJson: state.getJson,
  };
}
export default connect(mapStateToProps)(App);
